import { HTMLAttributes } from 'react'
import { LinkContainer } from './styles'

type Props = {
  icon?: React.ReactNode
  children?: React.ReactNode
} & HTMLAttributes<HTMLDivElement>

export const LinkButton = (props: Props) => {
  const { children, icon, ...otherProps } = props
  return (
    <LinkContainer {...otherProps}>
      {icon}
      {children}
    </LinkContainer>
  )
}
